import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AiSliceState } from '../types'

const initialState: AiSliceState = {
	aiPanelOpen: false,
	drawerOpen: false,
}

const aiSlice = createSlice({
	name: 'ai',
	initialState,
	reducers: {
		setAIPanelOpen: (state, action: PayloadAction<boolean>) => {
			state.aiPanelOpen = action.payload
		},
		toggleAIPanel: (state) => {
			state.aiPanelOpen = !state.aiPanelOpen
		},
		setAiRecentChatPanelOpen: (state, action: PayloadAction<boolean>) => {
			state.drawerOpen = action.payload
		},
		toggleAiRecentChatsPanel: (state) => {
			state.drawerOpen = !state.drawerOpen
		},
		requestViewRefresh: (state, action: PayloadAction<number>) => {
			const nodeId = action.payload
			const prevNonce = state.viewRefreshSignal?.nonce ?? 0
			state.viewRefreshSignal = { nodeId, nonce: prevNonce + 1 }
		},
	},
})

export const {
	setAIPanelOpen,
	toggleAIPanel,
	setAiRecentChatPanelOpen,
	toggleAiRecentChatsPanel,
	requestViewRefresh,
} = aiSlice.actions

export default aiSlice.reducer
